import React, { forwardRef } from 'react'
import cn from 'classnames'
import s from './textarea.module.css'
import type { TextareaProps } from './types'

const Input = (props: TextareaProps, ref: any) => {
  const { className, name, inputClassName, pure = false, ...rest } = props

  if (pure) {
    return <textarea className={cn(s.input, inputClassName)} ref={ref} name={name} {...rest} />
  }

  const { label, touched, error, ...prop } = rest

  return (
    <label htmlFor={name} className={cn(s.root, className)}>
      {label && <span className={s.label}>{label}</span>}
      <textarea className={cn(s.input, inputClassName)} ref={ref} name={name} {...prop} />
      <span className={s.alert} role="alert">
        {touched && error ? error : null}
      </span>
    </label>
  )
}

export default forwardRef(Input)
